import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
// import { navItems } from './sidebar-data';
import { NavService } from 'src/app/core/services/nav.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  @Output() toggleCollapse = new EventEmitter<void>();
  @Input() isCollapsed = false;
  navItems: any[] = [];

  constructor(public navService: NavService) { }

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      this.navItems = JSON.parse(localStorage.getItem('menu') as any);
    }
    
    // Subscribe để collapse sidebar khi có yêu cầu từ nav-item
    this.navService.toggleSidebar.subscribe(() => {
      if (!this.isCollapsed) {
        this.onToggleCollapse();
      }
    });
  }
  onToggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    localStorage.setItem('sidebar-collapsed', this.isCollapsed ? '1' : '0');
    this.toggleCollapse.emit(); // Gửi tín hiệu để toggle thu gọn

    if (this.isCollapsed) {
      this.navItems.forEach(item => item.isExpanded = false);
    }

    const tableDiv = document.getElementById('responsiveTable');
    if (tableDiv) {
      // Lấy kích thước màn hình hiện tại
      const width = window.innerWidth;

      // Xác định max-width phù hợp
      let maxWidth = '1520px'; // Mặc định cho màn lớn
      if (width >= 1024 && width <= 1530) {
        maxWidth = '1120px';
      }
      if (width >= 1024 && width <= 1320) {
        maxWidth = '920px';
      }

      // Toggle max-width
      if (tableDiv.style.maxWidth === maxWidth) {
        tableDiv.style.maxWidth = '';
      } else {
        tableDiv.style.maxWidth = maxWidth;
      }
    }
  }
}
